import { AxiosError } from "axios";
import { useSearchParams } from "react-router-dom";
import Layout from "components/Layout";
import { JsonViewer } from "./JsonViewer.index";
import { useApiPathFragment } from "utils/requests";
import SEO from "components/Seo";
import "highlight.js/styles/github.css";

const JsonViewerPage = () => {
  const [searchParams] = useSearchParams();

  const path = searchParams.get("path") || "";
  const { data, error, isLoading } = useApiPathFragment(path);

  let errorMsg = "";
  if (error && error instanceof AxiosError) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 404) {
      errorMsg = "The specified resource was not found.";
    } else if (axiosError.response?.status === 403) {
      errorMsg = "You are not authorized to view this resource.";
    } else {
      // @ts-ignore
      const detail = axiosError.response?.data?.message;
      errorMsg = `An error occurred while fetching the resource. ${detail}`;
    }
  }
  return (
    <Layout isShort>
      <SEO title="JSON Viewer" />
      <div className="grid-content">
        <JsonViewer
          json={data}
          path={path}
          message={errorMsg}
          isLoading={isLoading}
        />
      </div>
    </Layout>
  );
};

export default JsonViewerPage;
